import { motion } from "framer-motion";
import { useEffect, useRef, useState, useCallback } from "react";

const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

const squareData = [
  { id: 1, src: "/minimax-014927-0.jpeg" },
  { id: 2, src: "/minimax-024739-0.jpeg" },
  { id: 3, src: "/minimax-034732-0.jpeg" },
  { id: 4, src: "/minimax-034833-0.jpeg" },
  { id: 5, src: "/minimax-091614-0.jpeg" },
  { id: 6, src: "/minimax-100706-0.jpeg" },
  { id: 7, src: "/minimax-140527-0.jpeg" },
  { id: 8, src: "/minimax-161556-0.jpeg" },
  { id: 9, src: "/minimax-161729-0.jpeg" },
];

const generateSquares = () => {
  return shuffle(squareData).map((sq) => (
    <motion.div
      key={sq.id}
      layout
      transition={{ duration: 1.5, type: "spring" }}
      className="w-full h-full"
      style={{
        backgroundImage: `url(${sq.src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  ));
};

const ShuffleGrid = () => {
  const timeoutRef = useRef(null);
  const [squares, setSquares] = useState(generateSquares());

  const shuffleSquares = useCallback(() => {
    setSquares(generateSquares());
    timeoutRef.current = setTimeout(shuffleSquares, 3000);
  }, []);

  useEffect(() => {
    shuffleSquares();

    return () => clearTimeout(timeoutRef.current);
  }, [shuffleSquares]);

  return (
    <div className="grid grid-cols-3 grid-rows-3 h-[450px] gap-1">
      {squares.map((sq) => sq)}
    </div>
  );
};

export const DaisyHero = () => {
  return (
    <section className="w-full px-8 py-12 grid grid-cols-1 md:grid-cols-2 items-center gap-8 max-w-6xl mx-auto">
      <div>
        <span className="block mb-4 text-xs md:text-sm text-primary font-medium">
          Available on iOS
        </span>
        <h3 className="text-4xl md:text-6xl font-semibold">
          Find Your Perfect Teammates
        </h3>
        
        <p className="text-base md:text-lg text-base-content/70 my-4 md:my-6">
          Beanbag helps gamers find teammates who match their vibe.
          Swipe, match, and game on — no more frustrating lobbies or solo queues.
        </p>
        <div className="flex flex-wrap gap-4 items-center">
          <a href='https://apps.apple.com/pt/app/beanbag-chat/id6760129396?l=en-GB' target='_blank' rel='noopener noreferrer'>
            <img 
              src='https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg' 
              alt='Download on App Store' 
              className='h-12 hover:opacity-90 transition-opacity'
            />
          </a>
          <a href="#features">
            <button className="btn btn-ghost font-medium py-2 px-4">
              Learn More
            </button>
          </a>
        </div>
        
      </div>
      <ShuffleGrid />
    </section>
  );
};

export default DaisyHero;
